
<template>
  <div>
    <iframe style="opacity: 0" id="page-frame"></iframe>
    <div v-if="showLoader" class="loader-wrapper">
      <div class="loader"></div>
    </div>
  </div>
</template>

<script>

import {http} from "@/config/httpCommon";
import {handleResponseException} from "@/helpers/Helpers";

export default {
  data () {
    return {
      showLoader: true,
      order_id: this.$route.params.order_id,
      order_no: 0
    }
  },
  async mounted() {
    await this.getOrderData();
  },
  updated(){
    let title = `custimoo`;
    if(this.order_no){
      title = `${this.order_no}-custimoo`
    }
    window.document.title = title
  },
  methods : {
    printPDF() {
      let self = this;
      let url = `condensend-orders/${self.order_id}`
      if(this.$route.query.techpack_version) {
        url += `?techpack_version=${this.$route.query.techpack_version}`
      }
      http.get(url)
          .then((successResponse) => {
            const frame = document.getElementById("page-frame");
            const iframeDoc = frame.contentDocument || frame.contentWindow.document
            frame.srcdoc = successResponse.data;
            frame.addEventListener("load", () => {
              this.showLoader = false;
              frame.contentWindow.print();
              frame.contentWindow.onafterprint = () => {
                window.close();
              }
            });
          }).catch((errorResponse) => {
        console.log(errorResponse)
        handleResponseException(errorResponse)
      });
    },
    getOrderData() {
      let self = this;
      let url = `customer-orders/${self.order_id}`
      http.get(url)
          .then((successResponse) => {
            let response_data = successResponse.data;
            self.order = response_data.result;
            this.order_no = response_data.result.order_no
            let pdf_title = 'custimoo';
            if(response_data.result.order_no){
              pdf_title = `${response_data.result.order_no}-custimoo`;
            }
            window.document.title = pdf_title
            setTimeout(()=>{
              this.printPDF()
            }, 1300)

            if(self.isWebComponent)
              self.no_custimo_order = (!response_data.success)?true:false;
          }).catch((errorResponse) => {
            console.log(errorResponse)
          handleResponseException(errorResponse)
      });
    },
  }
}
</script>

<style lang="scss">
* {
  -webkit-print-color-adjust: exact !important; /*Chrome, Safari */
  color-adjust: exact !important; /*Firefox*/
}
html, body, #page-frame{
  margin: 0;
  padding: 0;
}

.loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 9999;
}

.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 6px solid #f3f3f3;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>